import { leaveLimitMessage } from 'src/app/Service/Person/PersonLeaveLimitSettings.service';
import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Empty_Persone_List_Interface, Persone_List_Interface } from 'src/app/Interface/Persone_List_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { PersonService } from 'src/app/Service/Person/Person.service';
import { PersonOffDayService } from 'src/app/Service/Person/PersonOffDay.service';

@Component({
  selector: 'app-PersonOffDayAdd',
  templateUrl: './PersonOffDayAdd.component.html',
  styleUrls: ['./PersonOffDayAdd.component.scss']
})
export class PersonOffDayAddComponent implements OnInit {

  constructor(
    private PersonOff_Service: PersonOffDayService,
    private Person_Service: PersonService,
    private Nav_Service: NavService,
    private Alertify_Service: AlertifyService,
    private modalService: BsModalService,
  ) { }

  ngOnInit() {

    this.AddNewOffday = new FormGroup({
      id: new FormControl(),
      endDate: new FormControl(),
      startDate: new FormControl(),
      dsc: new FormControl(null, Validators.required),
    })


    this.Nav_Service.CheckValidPage(2195).subscribe(
      data => {

      }
      , error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )


  }


  //#region  Form Add

  AddNewOffday: FormGroup;

  get_Form_endDate() {
    return this.AddNewOffday.get('endDate') as FormControl;
  }

  get_Form_startDate() {
    return this.AddNewOffday.get('startDate') as FormControl;
  }

  get_Form_dsc() {
    return this.AddNewOffday.get('dsc') as FormControl;
  }

  //#endregion



  //#region  Person

  modalRef_Person: any;
  page: number = 0

  ProcssingPerson: boolean = false

  Search_Name_Person_Table: string = ''

  openModal_Person(template: TemplateRef<any>) {
    this.modalRef_Person = this.modalService.show(template);
  }

  DataList_Person: Array<Persone_List_Interface> = []
  Data_Seleted_Record: Persone_List_Interface = Empty_Persone_List_Interface()



  ReadData_Person() {
    this.ProcssingPerson = true
    this.Person_Service.GetActive().subscribe(
      data => {
        this.DataList_Person = data
        this.ProcssingPerson = false
      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  Set_Selected_Person_Record(item) {
    this.Data_Seleted_Record = item
    this.modalRef_Person.hide()
  }

  //#endregion






  InProccessing: boolean = false
  Switcher_form: string = 'Insert'

  startDate_fulldate: string = ''
  endDate_fulldate: string = ''
  off: number = 0
  on: number = 0

  CheckOffday() {

    if (this.Data_Seleted_Record.id == 0) {
      this.Alertify_Service.ErrorMessage("فرد جایگزین را انتخاب نمائید")
    }
    else{
    this.InProccessing = true
    this.PersonOff_Service.CheckOffday(
      this.get_Form_startDate().value,
      this.get_Form_endDate().value,
      this.get_Form_dsc().value).subscribe(
        data => {
          this.InProccessing = false
          this.set_Switcher_form("Check")

          this.startDate_fulldate = data['startDate_fulldate']
          this.endDate_fulldate = data['endDate_fulldate']
          this.off = data['off']
          this.on = data['on']
        }, error => {
          this.InProccessing = false;
          this.set_Switcher_form('Insert');
          this.Alertify_Service.ErrorMessage(leaveLimitMessage(error));

        }
      )
    }
  }

  set_Switcher_form(item: string) {
    this.Switcher_form = item
  }

  SubmitAddNewOffday() {
    if (this.InProccessing) return;
    this.InProccessing = true
    this.PersonOff_Service.AddOffday(
      this.get_Form_startDate().value,
      this.get_Form_endDate().value,
      this.get_Form_dsc().value,
      this.Data_Seleted_Record.id).subscribe(
        data => {
          this.InProccessing = false
          if (data.id == -2) {
            this.Alertify_Service.ErrorMessage("در این بازه برای شما درخواستی ثبت شده است")
          }
          else if (data.id == -6) {
            this.Alertify_Service.ErrorMessage("در این بازه برای جایگزین درخواستی ثبت شده است")
          }
          else if (data.id == -1) {
            this.Alertify_Service.ErrorMessage("در بازه مرخصی، روز کاری وجود ندارد")
          }
          else if (data.id == -3) {
            this.Alertify_Service.ErrorMessage("گردش کار فعالی برای مرخصی روزانه انتخاب نشده است")
          }
          else if (data.id == -4) {
            this.Alertify_Service.ErrorMessage("خطا سیستمی")
          }
          else if (data.id == -5) {
            this.Alertify_Service.ErrorMessage("در چارت سازمانی بدون سمت هستید")
          }
          else {
            this.Data_Seleted_Record=Empty_Persone_List_Interface()
            this.AddNewOffday.reset()
            this.set_Switcher_form('Insert')
            this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")
          }
        }, error => {
          this.InProccessing = false;
          this.set_Switcher_form('Insert');
          this.Alertify_Service.ErrorMessage(leaveLimitMessage(error));

        }
      )
  }

}
